import { useState, useEffect } from 'react'
import ReactGA from 'react-ga'
import './GdprFooter.css'

const GdprFooter = () => {
    const ID = 'G-XH8XH13YX4'
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const local = localStorage.getItem('cookiePermission')

        if (local) {
            ReactGA.initialize(ID)
            ReactGA.pageview(window.location.pathname)
            return
        }

        setOpen(true)
    }, [])

    const givePermission = () => {
        ReactGA.initialize(ID)
        ReactGA.pageview(window.location.pathname)
        const date = new Date()
        try {
            localStorage.setItem('cookiePermission', `Lupa evästeille annettu ${date.toISOString()}`)
        } catch {

        }
        setOpen(false)
    }

    if (!open) return null

    return (
        <div className='footer-container'>
            <div>
                Mukavalla asialla käyttää kolmannen osapuolen evästeitä, mutta ainoastaan mittaamaan kuinka moni käy pelaamassa.
            </div>
            <button className='footer-button' onClick={() => givePermission()}>Hyväksy</button>
            <button className='footer-button' onClick={() => setOpen(false)}>Hylkää</button>
        </div>
    )
}

export default GdprFooter